<template>
    <zen-one
        :showuserinfo="false"
        :crumbs="crumbs"
        title="Sistem Hasil Bersepadu Kedah (iHasil)"
    >
        <z-page title="Kaunter : Tutup Akhir">
            <div class="message-box">
                <w-transition-fade>
                    <w-alert
                        class="my0 text-light"
                        v-if="form.submitted"
                        success
                        no-border
                    >
                        The form is valid, ready to send it!
                    </w-alert>

                    <w-alert
                        class="my0 text-light"
                        v-else-if="form.valid === false"
                        error
                        no-border
                    >
                        Terdapat {{ form.errorsCount }} ralat di dalam borang
                        ini.
                    </w-alert>
                </w-transition-fade>
            </div>

            <w-form
                class=""
                v-model="form.valid"
                v-model:errors-count="form.errorsCount"
                @validate="onValidate"
                @success="onSuccess"
            >
                <w-flex justify-center align-center>
                    <div class="xs6">
                        <h5 class="fw-semibold m0">Tarikh :</h5>
                        <div class="fw-normal my1 fs-1">
                            {{ currentDate() }}
                        </div>
                    </div>
                    <div class="xs6">
                        <h5 class="fw-semibold m0">Kaunter :</h5>
                        <div class="fw-normal my1 fs-1">
                            <template v-if="form.kaunter">{{
                                form.kaunter.kod
                            }}</template>
                        </div>
                    </div>
                </w-flex>
                <w-flex justify-center align-center class="mt5">
                    <loading v-model:active="isLoading"
                    :can-cancel="false"
                    :opacity="0.7"
                    :is-full-page="false"/>
                    <div class="w-card__content content-hardcode">
                        <table class="w-table" width="100%">
                            <thead>
                                <tr>
                                    <th class="w-table__header" rowspan="2">
                                        <b>No</b>
                                    </th>
                                    <th class="w-table__header" rowspan="2">
                                        <b>Cara Bayaran</b>
                                    </th>
                                    <th class="w-table__header" colspan="2">
                                        <b>Kuat Kuasa</b>
                                    </th>
                                    <th class="w-table__header" colspan="2">
                                        <b>Resit Batal</b>
                                    </th>
                                </tr>
                                <tr>
                                    <th class="w-table__header">
                                        <b>Bil. Resit </b>
                                    </th>
                                    <th class="w-table__header">
                                        <b>Amaun (RM)</b>
                                    </th>
                                    <th class="w-table__header">
                                        <b>Bil. Resit </b>
                                    </th>
                                    <th class="w-table__header">
                                        <b>Amaun (RM)</b>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(dt, index) in form.cara_bayar">
                                    <td class="table__cell" align="center">
                                        {{ index + 1 }}
                                    </td>
                                    <td class="table__cell">
                                        {{ dt.keterangan }}
                                    </td>
                                    <td class="table__cell" align="center">
                                        <inertia-link
                                            :href="
                                                $route(
                                                    'kutipan.kaunter.resit',
                                                    [dt.id, 1]
                                                )
                                            "
                                            >{{ dt.bil }}</inertia-link
                                        >
                                    </td>
                                    <td class="table__cell" align="right">
                                        {{ $zutil.currency(dt.amaun) }}
                                    </td>
                                    <td class="table__cell" align="center">
                                        {{ dt.bil_batal }}
                                    </td>
                                    <td class="table__cell" align="right">
                                        {{ $zutil.currency(dt.amaun_batal) }}
                                    </td>
                                </tr>
                                <tr>
                                    <td></td>
                                    <td class="w-table__header">
                                        <b>Jumlah</b>
                                    </td>
                                    <td class="w-table__header" align="center">
                                        <b>{{ form.bil }}</b>
                                    </td>
                                    <td class="w-table__header" align="right">
                                        <b>{{ $zutil.currency(form.total) }}</b>
                                    </td>
                                    <td class="w-table__header" align="center">
                                        <b>{{ form.bil_batal }}</b>
                                    </td>
                                    <td class="w-table__header" align="right">
                                        <b>{{
                                            $zutil.currency(form.total_batal)
                                        }}</b>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </w-flex>

            <center v-if="tutup.loading"><w-progress class="ma1" circle></w-progress></center>

                <w-flex justify-center align-cente class="mt2">
                    <div class="xs12">
                        <w-textarea
                            no-autogrow
                            rows="8"
                            placeholder="Sila Masukkan Catatan Disini"
                            v-model="form.catatan"
                        >
                            Catatan
                        </w-textarea>
                    </div>
                </w-flex>

                <w-flex class="mt4" wrap align-center justify-end>
                    <div class="spacer" />
                    <template v-if="$zutil.can('Kaunter Tutup Akhir')">
                        <w-button
                            class="my1"
                            type="submit"
                            :disabled="form.valid === false"
                            :loading="form.submitted && !form.sent"
                        >
                            <w-icon dark tile>fal fa-save</w-icon>
                        </w-button>
                    </template>

                    <template v-if="form.ind_buka == 0">
                        <!-- <template v-if="form.user_id == $page.props.auth.user.id"> -->
                        <w-button class="ml1" @click="send(2, form)" :loading="tutup.loading">
                            Tutup
                        </w-button>
                        <!-- </template> -->
                    </template>
                </w-flex>
            </w-form>
        </z-page>
    </zen-one>
</template>

<script>
import Vue3ChartJs from "@j-t-mcc/vue3-chartjs";
import ZResource from "@/Modules/z-resource-service";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';

export default {
    extends: ZResource,
    components: {
        Vue3ChartJs,
        Loading,
    },
    props: {
        id: [Array, Object, String],
    },
    setup() {
        const doughnutChart = {
            id: "doughnut",
            type: "doughnut",
            data: {
                labels: ["VueJs", "EmberJs", "ReactJs", "AngularJs"],
                datasets: [
                    {
                        backgroundColor: [
                            "#37479e",
                            "#2f3d88",
                            "#273371",
                            "#1f285a",
                        ],
                        data: [40, 20, 80, 10],
                    },
                ],
            },
            options: { plugins: { legend: { display: false } } },
        };

        const beforeRenderLogic = (event) => {
            //...
            //if(a === b) {
            //  event.preventDefault()
            //}
        };

        return {
            doughnutChart,
            beforeRenderLogic,
        };
    },
    data() {
        return {
            resourceurl: this.service_kutipan + "kaunter/summary",
            tutup : {
              loading: false,
            },
            dialog: {
                show: false,
                show2: false,
                fullscreen: false,
                persistent: false,
                persistentNoAnimation: false,
                width: 500,
            },
            form: {
                valid: null,
                submitted: false,
                sent: false,
                errorsCount: 0,
            },
            validators: {
                required: (value) => !!value || "This field is required",
                consent: (value) => !!value || "You must agree",
            },
            crumbs: [
                { label: "iHasil", route: "/" },
                { label: "Kutipan", route: "/kutipan" },
                { label: "Kaunter", route: "/kaunter" },
                { label: "Tutup Akhir", route: "/Kaunter/akhir" },
            ],
            showCard: false,
            isLoading: true,
        };
    },
    watch: {
        form(){
            this.isLoading = false
        }
    },
    methods: {
        onSuccess() {
            setTimeout(() => (this.form.sent = true), 2000);
            this.$inertia.visit(window.route("kutipan.kaunter.akhir"));
        },
        onValidate() {
            this.form.sent = false;
            this.form.submitted = this.form.errorsCount === 0;
        },

        currentDate() {
            const current = new Date();
            const date = `${current.getDate()}/${
                current.getMonth() + 1
            }/${current.getFullYear()}`;
            return date;
        },

        send(status, form) {
            this.tutup.loading = true
            //   this.form = mapValues(this.form, () => null)
            this.form.lkp_kaunter_status_id = status;
            this.form.id = form.kaunter_id;
            this.form.profil_id = 0;
            this.$zcomm
                .update(
                    this.service_kutipan + "kaunter" + "/" + this.form.id,
                    this.form.id,
                    this.form
                )
                .then((res) => {
                    this.$zutil.notify("Kaunter Berjaya Ditutup");
                    this.$inertia.visit(this.$route("kutipan.kaunter.buka"));
                })
                .catch((err) => {})
                .finally(() => {});
        },
    },
};
</script>

<style></style>
